// document.addEventListener("DOMContentLoaded", () => {
//   // Find all file upload containers
//   const fileUploadContainers = document.querySelectorAll(
//     ".file-upload-container"
//   );

//   fileUploadContainers.forEach((container) => {
//     const fileInput = container.querySelector("input[type='file']");
//     const fileList = container.querySelector("ul");

//     fileInput.addEventListener("change", () => {
//       const files = Array.from(fileInput.files);

//       // Clear the file list
//       fileList.innerHTML = "";

//       files.forEach((file, index) => {
//         const listItem = document.createElement("li");
//         listItem.className = "position-relative border p-2 thumb_wrapp";

//         const thumbnail = document.createElement("img");
//         thumbnail.src = URL.createObjectURL(file);
//         thumbnail.alt = file.name;
//         thumbnail.style.width = "100px";
//         thumbnail.style.height = "100px";
//         thumbnail.style.objectFit = "cover";

//         const removeOverlay = document.createElement("div");
//         removeOverlay.className =
//           "thumb-overlay position-absolute top-50 start-50 translate-middle w-100 h-100 d-flex align-items-center justify-content-center";

//         const removeButton = document.createElement("button");
//         removeButton.className = "btn btn-primary btn-sm rounded-0";
//         removeButton.innerHTML = `<i class="fa-light fa-trash text-white"></i>`;

//         removeButton.addEventListener("click", () => {
//           const updatedFiles = Array.from(fileInput.files).filter(
//             (_, i) => i !== index
//           );

//           const dataTransfer = new DataTransfer();
//           updatedFiles.forEach((updatedFile) =>
//             dataTransfer.items.add(updatedFile)
//           );
//           fileInput.files = dataTransfer.files;

//           listItem.remove();
//         });

//         listItem.appendChild(thumbnail);
//         removeOverlay.appendChild(removeButton);
//         listItem.appendChild(removeOverlay);
//         fileList.appendChild(listItem);
//       });
//     });
//   });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   // Find all file upload containers
//   const fileUploadContainers = document.querySelectorAll(
//     ".file-upload-container"
//   );

//   fileUploadContainers.forEach((container) => {
//     const fileInput = container.querySelector("input[type='file']");
//     const fileList = container.querySelector("ul");

//     fileInput.addEventListener("change", () => {
//       const newFiles = Array.from(fileInput.files);
//       console.log(newFiles, 'fileinput');
//       // Get existing files from a custom attribute or initialize it
//       const existingFiles =
//         container.__uploadedFiles || [];

//       // Combine existing files with new ones
//       const updatedFiles = [...existingFiles, ...newFiles];

//       // Deduplicate files by name and size
//       const uniqueFiles = updatedFiles.filter(
//         (file, index, self) =>
//           self.findIndex(
//             (f) => f.name === file.name && f.size === file.size
//           ) === index
//       );

//       // Update the custom attribute with the new file list
//       container.__uploadedFiles = uniqueFiles;

//       // Clear the file list
//       fileList.innerHTML = "";

//       uniqueFiles.forEach((file, index) => {
//         const listItem = document.createElement("li");
//         listItem.className = "position-relative border p-2 thumb_wrapp";

//         const thumbnail = document.createElement("img");
//         thumbnail.src = URL.createObjectURL(file);
//         thumbnail.alt = file.name;
//         thumbnail.style.width = "100px";
//         thumbnail.style.height = "100px";
//         thumbnail.style.objectFit = "cover";

//         const removeOverlay = document.createElement("div");
//         removeOverlay.className =
//           "thumb-overlay position-absolute top-50 start-50 translate-middle w-100 h-100 d-flex align-items-center justify-content-center";

//         const removeButton = document.createElement("button");
//         removeButton.className = "btn btn-primary btn-sm rounded-0";
//         removeButton.innerHTML = `<span class="btn-text"><i class="fa-light fa-trash"></i></span>`;

//         removeButton.addEventListener("click", () => {
//           // Remove the file from the uploaded list
//           const updatedFileList = container.__uploadedFiles.filter(
//             (_, i) => i !== index
//           );
//           container.__uploadedFiles = updatedFileList;

//           // Update the DataTransfer object
//           const dataTransfer = new DataTransfer();
//           updatedFileList.forEach((updatedFile) =>
//             dataTransfer.items.add(updatedFile)
//           );
//           fileInput.files = dataTransfer.files;

//           // Remove the thumbnail
//           listItem.remove();
//         });

//         listItem.appendChild(thumbnail);
//         removeOverlay.appendChild(removeButton);
//         listItem.appendChild(removeOverlay);
//         fileList.appendChild(listItem);
//       });

//       // Update the file input with the unique files
//       const dataTransfer = new DataTransfer();
//       uniqueFiles.forEach((file) => dataTransfer.items.add(file));
//       fileInput.files = dataTransfer.files;
//     });
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  const fileUploadContainers = document.querySelectorAll(
    ".file-upload-container"
  );

  fileUploadContainers.forEach((container) => {
    const fileInput = container.querySelector("input[type='file']");
    const fileList = container.querySelector("ul");

    // Create validation message element (initially hidden)
    let validationMessage = document.createElement("div");
    validationMessage.className =
      "invalid-feedback d-block bg-danger-subtle text-danger-emphasis";
    validationMessage.style.display = "none";
    container.appendChild(validationMessage);

    fileInput.addEventListener("change", () => {
      const newFiles = Array.from(fileInput.files);
      const allowedTypes = ["image/jpeg", "image/png"];
      const maxSize = 2 * 1024 * 1024; // 2MB
      let errorMessage = "";

      // Validate files
      const validFiles = newFiles.filter((file) => {
        if (!allowedTypes.includes(file.type)) {
          errorMessage = "Only JPEG and PNG formats are allowed!";
          return false;
        }
        if (file.size > maxSize) {
          errorMessage = "File size must be under 2MB!";
          return false;
        }
        return true;
      });

      if (validFiles.length === 0) {
        // Show validation message only when an error occurs
        validationMessage.innerHTML = `<p class="p-3">${errorMessage}</p>`;
        validationMessage.style.display = "block";
        fileInput.classList.add("is-invalid");
        return;
      }

      // **SUCCESS CASE** - Remove error messages
      validationMessage.style.display = "none";
      validationMessage.innerText = "";
      fileInput.classList.remove("is-invalid");

      // Manage uploaded files
      const existingFiles = container.__uploadedFiles || [];
      const updatedFiles = [...existingFiles, ...validFiles].filter(
        (file, index, self) =>
          self.findIndex(
            (f) => f.name === file.name && f.size === file.size
          ) === index
      );

      container.__uploadedFiles = updatedFiles;

      // Clear previous thumbnails
      fileList.innerHTML = "";

      updatedFiles.forEach((file, index) => {
        const listItem = document.createElement("li");
        listItem.className = "position-relative border p-2 thumb_wrapp";

        const thumbnail = document.createElement("img");
        thumbnail.src = URL.createObjectURL(file);
        thumbnail.alt = file.name;
        thumbnail.style.width = "100px";
        thumbnail.style.height = "100px";
        thumbnail.style.objectFit = "cover";

        const removeOverlay = document.createElement("div");
        removeOverlay.className =
          "thumb-overlay position-absolute top-50 start-50 translate-middle w-100 h-100 d-flex align-items-center justify-content-center";

        const removeButton = document.createElement("button");
        removeButton.className = "btn btn-primary btn-sm rounded-0";
        removeButton.innerHTML = `<span class="btn-text"><i class="fa-light fa-trash"></i></span>`;

        removeButton.addEventListener("click", () => {
          container.__uploadedFiles = container.__uploadedFiles.filter(
            (_, i) => i !== index
          );

          const dataTransfer = new DataTransfer();
          container.__uploadedFiles.forEach((updatedFile) =>
            dataTransfer.items.add(updatedFile)
          );
          fileInput.files = dataTransfer.files;

          listItem.remove();
        });

        listItem.appendChild(thumbnail);
        removeOverlay.appendChild(removeButton);
        listItem.appendChild(removeOverlay);
        fileList.appendChild(listItem);
      });

      // Update the file input
      const dataTransfer = new DataTransfer();
      updatedFiles.forEach((file) => dataTransfer.items.add(file));
      fileInput.files = dataTransfer.files;
    });
  });
});
